import { render, staticRenderFns } from "./AppointmentFormCP.vue?vue&type=template&id=02bb6728&scoped=true"
import script from "./AppointmentFormCP.vue?vue&type=script&lang=js"
export * from "./AppointmentFormCP.vue?vue&type=script&lang=js"
import style0 from "./AppointmentFormCP.vue?vue&type=style&index=0&id=02bb6728&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb6728",
  null
  
)

export default component.exports